module.exports = __webpack_public_path__ + "img/folder.116ec1f6.svg";